/**
 * Partner Benefits DTOs - /api/v1/partner-benefits (Club de Beneficios)
 *
 * Campos en camelCase para alinearse con el backend Go (JSON tags).
 */

export type PartnerBenefitCategory =
  | 'food'
  | 'cafe'
  | 'ecommerce'
  | 'hotel'
  | 'walking'
  | 'funeral'
  | 'pet_services'
  | 'vet'
  | 'supplement'
  | 'transport';

export interface PartnerLocation {
  address: string;
  city: string;
}

export interface PartnerBenefitResponse {
  id: string;
  partnerName: string;
  category: PartnerBenefitCategory;
  shortDescription: string;
  longDescription?: string;
  logoUrl?: string;
  discountText?: string;
  schedule?: string;
  validUntil?: string;
  isNew: boolean;
  isActive: boolean;
  website?: string;
  howToRedeem?: string;
  locations?: PartnerLocation[];
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface PartnerBenefitsListParams {
  category?: PartnerBenefitCategory;
  valid?: boolean;
  new?: boolean;
  search?: string;
}

/** Labels en español para mostrar al usuario. */
export const PARTNER_BENEFIT_CATEGORY_LABELS: Record<PartnerBenefitCategory, string> = {
  food: 'Alimento',
  cafe: 'Cafetería de especialidad',
  ecommerce: 'E-Commerce',
  hotel: 'Hotelería',
  walking: 'Paseos',
  funeral: 'Servicios funerarios',
  pet_services: 'Servicios para mascotas',
  vet: 'Servicios veterinarios',
  supplement: 'Suplemento alimenticio',
  transport: 'Traslado de mascotas',
};
